<template>
<div v-if="match_report">
    <div class="row columns">
        <div class="large-6 columns match-actions-left">
            <div class="row">
                <table>
                    <thead class="roster-head">
                        <tr>
                          <th width="6%">N°</th>
                          <th width="5%">Réu</th>
                          <th width="5%">TTM</th>
                          <th width="5%">Det</th>
                          <th width="5%">Int</th>
                          <th width="5%">Sor</th>
                          <th width="5%">TD</th>
                          <th width="6%">JPV</th>
                          <th width="5%">Expulsion</th>
                          <th width="5%">Agro</th>
                          <th width="5%">XPB</th>
                          <th width="18%">Blessure</th>
                        </tr>
                    </thead>
                    <tbody class="roster">
                        <tr v-for="action of match_report.home_report.player_report" v-if="action.player">
                          <td>{{action.player.num}}</td>
                          <td>{{action.nb_pass}}</td>
                          <td>{{action.nb_ttm}}</td>
                          <td>{{action.nb_det}}</td>
                          <td>{{action.nb_int}}</td>
                          <td>{{action.nb_cas}}</td>
                          <td>{{action.nb_td}}</td>
                          <td v-if="action.mvp">Oui</td>
                          <td v-else>Non</td>
                          <td v-if="action.nb_red_card">Oui</td>
                          <td v-else>Non</td>
                          <td>{{action.nb_foul}}</td>
                          <td>{{action.bonus_xp}}</td>
                          <td>{{getWound(action.injury_type)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="large-6 columns match-actions-right">
            <div class="row">
                <table>
                    <thead class="roster-head">
                        <tr>
                          <th width="6%">N°</th>
                          <th width="5%">Réu</th>
                          <th width="5%">TTM</th>
                          <th width="5%">Det</th>
                          <th width="5%">Int</th>
                          <th width="5%">Sor</th>
                          <th width="5%">TD</th>
                          <th width="6%">JPV</th>
                          <th width="5%">Expulsion</th>
                          <th width="5%">Agro</th>
                          <th width="5%">XPB</th>
                          <th width="18%">Blessure</th>
                        </tr>
                    </thead>
                    <tbody class="roster">
                        <tr v-for="action of match_report.visitor_report.player_report">
                          <td>{{action.player.num}}</td>
                          <td>{{action.nb_pass}}</td>
                          <td>{{action.nb_ttm}}</td>
                          <td>{{action.nb_det}}</td>
                          <td>{{action.nb_int}}</td>
                          <td>{{action.nb_cas}}</td>
                          <td>{{action.nb_td}}</td>
                          <td v-if="action.mvp">Oui</td>
                          <td v-else>Non</td>
                          <td v-if="action.nb_red_card">Oui</td>
                          <td v-else>Non</td>
                          <td>{{action.nb_foul}}</td>
                          <td>{{action.bonus_xp}}</td>
                          <td>{{getWound(action.injury_type)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<div v-else>
<spinner></spinner>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'

export default {
  name: 'playerReportViewer',
  components: {
    spinner
  },
  props: {
    'match_report': {}
  },
  data () {
    return {
    }
  },
  methods: {
    getWound (woundId) {
      if (woundId === null) {
        return ''
      }
      if (woundId === 0) {
        return 'commotion'
      }
      if (woundId === 1) {
        return 'manque le prochain match'
      }
      if (woundId === 2) {
        return 'Blessure Persistante'
      }
      if (woundId === 4) {
        return '-1 en Ar'
      }
      if (woundId === 3) {
        return '-1 en Mv'
      }
      if (woundId === 5) {
        return '-1 en Ag'
      }
      if (woundId === 6) {
        return '-1 en Fo'
      }
      if (woundId === 7) {
        return 'R.I.P'
      }
    }
  },
  created () {
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.match-actions-left{
    padding-right: 1.5rem;
}

.match-actions-rihgt{
    padding-left: 1.5rem;
}

.big-title {
    font-size: 1.6rem;
}
.match-team-name {
    font-size: 1.3rem;
}
.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

tr td{
    padding: 0.5rem 0.2rem;
    text-align: center;
    font-size:0.7rem;
}
tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}

button.row{
    margin-left: 0.4rem;
}

.note {
 font-size: 0.6rem;
}

</style>



// WEBPACK FOOTER //
// player-report-viewer.vue?8e098e6e